import { api } from "./client";

export const authApi = {
  login: (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data.user),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};
